import React, { useState, useEffect } from "react"
import { Col, Container, Row } from "reactstrap"
import "assets/scss/website/app.scss"
import { MetaTags } from "react-meta-tags" 
import { SuccessOk } from "configs/statusCode"
import Navbar from "components/Website/Layouts/Navbar"
import Footer from "components/Website/Layouts/Footer"
import { useTranslation } from 'react-i18next'
import DealService from "services/Website/DealService"
import { toast } from "react-toastify"


const Home = (props) => {
    const { t } = useTranslation()
    const status = props.match.params.status
    const id = props.match.params.id
    const dealService = new DealService()
    useEffect(() => {
        if (id && status) {
            dealService.changeStatus(id, status).then(res => {
                if (res && res.status === SuccessOk) {
                    toast.success("Deal status updated  successfully")
                    props.history.push("/")
                }
            })
        }
    }, [])

    return (
        <React.Fragment>
            <Navbar />
            <div className='websitPages'>
                <MetaTags>
                    <title>{t("home")}</title>
                </MetaTags>
                <div>
                     <Container fluid className='px-lg-5'>
                        <Row>
                        </Row>
                    </Container>
                </div>
            </div>
            <Footer />
        </React.Fragment>

    )
}

export default Home
